/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { ClientSDK } from "../lib/sdks.js";
import { Blocks } from "./blocks.js";
import { Categories } from "./categories.js";
import { CustomRules } from "./customrules.js";
import { Evals } from "./evals.js";
import { Exclusions } from "./exclusions.js";
import { Expr } from "./expr.js";
import { Overview } from "./overview.js";
import { Policies } from "./policies.js";
import { PolicyBypassRequests } from "./policybypassrequests.js";
import { PolicyChallenges } from "./policychallenges.js";
import { Presets } from "./presets.js";
import { Results } from "./results.js";
import { Rules } from "./rules.js";
import { SessionQuarantines } from "./sessionquarantines.js";
import { Signals } from "./signals.js";

export class Risk extends ClientSDK {
  private _policyChallenges?: PolicyChallenges;
  get policyChallenges(): PolicyChallenges {
    return (this._policyChallenges ??= new PolicyChallenges(this._options));
  }

  private _policyBypassRequests?: PolicyBypassRequests;
  get policyBypassRequests(): PolicyBypassRequests {
    return (this._policyBypassRequests ??= new PolicyBypassRequests(
      this._options,
    ));
  }

  private _expr?: Expr;
  get expr(): Expr {
    return (this._expr ??= new Expr(this._options));
  }

  private _customRules?: CustomRules;
  get customRules(): CustomRules {
    return (this._customRules ??= new CustomRules(this._options));
  }

  private _exclusions?: Exclusions;
  get exclusions(): Exclusions {
    return (this._exclusions ??= new Exclusions(this._options));
  }

  private _policies?: Policies;
  get policies(): Policies {
    return (this._policies ??= new Policies(this._options));
  }

  private _signals?: Signals;
  get signals(): Signals {
    return (this._signals ??= new Signals(this._options));
  }

  private _blocks?: Blocks;
  get blocks(): Blocks {
    return (this._blocks ??= new Blocks(this._options));
  }

  private _overview?: Overview;
  get overview(): Overview {
    return (this._overview ??= new Overview(this._options));
  }

  private _categories?: Categories;
  get categories(): Categories {
    return (this._categories ??= new Categories(this._options));
  }

  private _results?: Results;
  get results(): Results {
    return (this._results ??= new Results(this._options));
  }

  private _presets?: Presets;
  get presets(): Presets {
    return (this._presets ??= new Presets(this._options));
  }

  private _sessionQuarantines?: SessionQuarantines;
  get sessionQuarantines(): SessionQuarantines {
    return (this._sessionQuarantines ??= new SessionQuarantines(this._options));
  }

  private _rules?: Rules;
  get rules(): Rules {
    return (this._rules ??= new Rules(this._options));
  }

  private _evals?: Evals;
  get evals(): Evals {
    return (this._evals ??= new Evals(this._options));
  }
}
